  // 等待页面加载完成
document.addEventListener('DOMContentLoaded', function() {
  // 监听按钮容器的点击事件（使用捕获阶段）
  document.addEventListener('click', function(e) {
    
    // 匹配带wQuickAddHandler的按钮容器
    const targetBtn = e.target.closest('.wqbtn-container[onclick*="wQuickAddHandler"]');
    if (targetBtn) {
      // 1. 阻止事件立即触发原函数（避免重复执行）
      e.stopImmediatePropagation();
       var cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer')
      console.log(cart,"cart")
      const cardWrapper = targetBtn.closest('.card-wrapper');
      const parent = targetBtn.parentElement;
      const variantValueElement = parent.querySelector('.wqbtn-variant-value-wrapper .wqbtn-variant-value');
      let selectVal = variantValueElement ? variantValueElement.textContent.trim() : '';
      
      // 获取数量值（转为数字类型）
      const quantityInput = parent.querySelector(".wqbtn-quantity-wrapper input");
      const numVal = quantityInput ? parseInt(quantityInput.value) : 1;
      let prod = {}
      const handle = cardWrapper?.dataset.handle
      fetch(window.Shopify.routes.root + `products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
         console.log(product,"product")
        selectVal = product.variants.find(item => item.title == selectVal).id
        var data = {
        id: selectVal,
        quantity: numVal,
      }
      if (cart) {
        data['sections'] = cart.getSectionsToRender().map(section => section.id)
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function (res) {
          console.log(res, '---12312--')
      
          if (!cart) {
            console.log('加购.....1......')
            window.location = window.routes.cart_url
            // that.closePop();
          } else {
            cart.renderContents(res)
            if (cart && cart.classList.contains('is-empty'))
              cart.classList.remove('is-empty')
          }
        },
        dataType: 'json',
      })
      });
       
      // 2. 执行自定义逻辑
      console.log('自定义添加到购物车处理');
      // customAddToCart(e, targetBtn); // 你的自定义函数
      
      // 3. 可选：执行原函数（如果需要保留插件原有功能）
      // const originalOnClick = new Function('event', 'this', targetBtn.getAttribute('onclick'));
      // originalOnClick.call(targetBtn, e, targetBtn);
      
    }
  }, true); // 第三个参数true表示在捕获阶段触发，确保优先拦截
})